import z from 'zod';

export const DATA_ZONE_OPTION = ['Bronze', 'Silver', 'Gold'] as const;
export type DataZone = (typeof DATA_ZONE_OPTION)[number];

export const DATA_ZONE_LOWER_CASE = ['bronze', 'silver', 'gold'] as const;
export type DataZoneLowerCaseString = (typeof DATA_ZONE_LOWER_CASE)[number];
export const dataZoneLowerCaseSchema = z.enum(DATA_ZONE_LOWER_CASE);

export type DataZoneCountType = 'total' | 'incremental';
export type QualityDetailDateRange = 1 | 3 | 7 | 14 | 30 | 60;

export type QualityLevel = 'high' | 'medium' | 'low';

export type SelectedSortByValue = '-collectedAt' | '-goodRatio' | 'goodRatio';
